<template>
  <div class="searchForm" :class="showLabel ? 'p-3 mt-2' : ''">
    <el-row :gutter="10">
      <el-col
        :xl="14"
        :lg="14"
        :md="10"
        :sm="24"
        style="position: relative"
        class="supplierSearch"
      >
        <label for="search" v-if="showLabel">اختر اسم المورد</label>
        <input
          @focus="resetSearch"
          type="text"
          class="form-control"
          readonly
          v-model="placeholder"
          id=""
          v-if="selectedSupplier"
        />
        <el-select
          v-else
          @change="supplierSelected"
          class="search supplierQuery"
          @focus="options = []"
          v-model="value"
          :loading-text="loadingMsg"
          :no-data-text="noDataMsg"
          filterable
          popper-class="searchDropdown"
          remote
          :clearable="true"
          :placeholder="placeholder"
          :remote-method="remoteMethod"
          :loading="loading"
        >
          <el-option
            ref="supplierQuery"
            v-for="item in options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
            <span style="float: right">
              {{ item.name }} - {{ item.address }}</span
            >
          </el-option>
          <el-option v-if="accessLinks('add_new_customer')" value="0">
            <el-button
              v-if="addsupplier"
              class="addCustomer"
              @click="handleSearchEnter"
            >
              إضافة مورد جديد</el-button
            >
          </el-option>
        </el-select>
      </el-col>

      <el-col
        :xl="5"
        :lg="5"
        :md="10"
        :sm="24"
        v-if="$route.path != '/suppliers/payment'"
        class="projectSearch"
      >
        <h6 class="mb-1">اسم المشروع</h6>
        <el-select
          style="width: 100%"
          @change="selectProject()"
          v-model="project_id"
          placeholder="اختر المشروع"
        >
          <el-option
            v-for="item in projects"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col
        v-if="selectedSupplier && searchOnly == false"
        :xl="5"
        :lg="5"
        :md="4"
        :sm="24"
        class="supplier-account"
      >
        <div class="bg-White result mt-2">
          <p>
            <span class="num" v-if="supplierAccount >= 0">{{
              numberToFixed(supplierAccount)
            }}</span>
            <span class="num" v-else>{{
              numberToFixed(supplierAccount * -1)
            }}</span>
            <br class="display-mobile-none" />
            <span v-if="supplierAccount >= 0">دائن</span>
            <span v-else>مدين</span>
          </p>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      title="تسجيل مورد جديد"
      :visible.sync="addFormVisible"
      v-if="supplierForm"
    >
      <el-form :model="supplierForm" :rules="rules" ref="supplierForm">
        <el-row :gutter="10">
          <el-col :xl="12" :lg="12" :md="6" :sm="12">
            <el-form-item label="الاسم " prop="name">
              <el-input
                class="formInput1"
                autofocus
                v-model="supplierForm.name"
                autocomplete="off"
                @keyup.enter.native="focusNext"
              ></el-input>
            </el-form-item>
            <!-- @focus="$event.target.select()" -->
          </el-col>
          <el-col :xl="6" :lg="6" :md="12" :sm="12">
            <el-form-item label="رصيد المورد " prop="account">
              <el-input
                class="formInput2"
                id="account"
                type="number"
                @focus="$event.target.select()"
                v-model="supplierForm.account"
                controls-position="right"
                @keyup.enter.native="focusNext"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="6" :lg="6" :md="12" :sm="12">
            <el-form-item label="رقم الهاتف " prop="phone">
              <el-input
                class="formInput3"
                id="phone"
                @focus="$event.target.select()"
                v-model="supplierForm.phone"
                @keyup.enter.native="focusNext"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="24" :lg="24" :md="24" :sm="24">
            <el-form-item label="العنوان  " prop="address">
              <el-input
                class="formInput4"
                id="address"
                @focus="$event.target.select()"
                v-model="supplierForm.address"
                @keyup.enter.native="focusNext"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" plain @click="addNewCustomer"
          >تسجيل المورد
        </el-button>
        <el-button class="mr-3" @click="addFormVisible = false"
          >إلغاء</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";

export default {
  name: "Searchsuppliers",
  props: [
    "productsLength",
    "supplier",
    "productSearch",
    "searchOnly",
    "showLabel",
    "useParcode",
  ],

  data() {
    return {
      projects: [],
      project_id: "",
      index: 1,
      rules: {
        name: [{ required: true, message: "حدد اسم المورد", trigger: "blur" }],
        account: [
          { required: true, message: "حدد الرصيد الافتتاحي", trigger: "blur" },
        ],
        // address: [{ required: true, message: "حدد العنوان ", trigger: "blur" }],
        // phone: [
        //   { required: true, message: "حدد رقم الهاتف", trigger: "blur" },
        //   { min: 11, max: 11, message: "حدد رقم هاتف صحيح", trigger: "change" },
        // ],
      },
      selectedLabel: "",
      noDataMsg: "لا توجد بيانات متاحه",
      loadingMsg: " ... جاري تحميل البيانات",
      options: [],
      value: null,
      loading: false,
      placeholder: this.supplier ? this.supplier.name : "بحث الموردين",
      selectedSupplier: this.supplier,
      supplierAccount: this.supplier
        ? +this.supplier.account + +this.supplier.balance
        : 0,
      addFormVisible: false,
      addsupplier: false,
      supplierForm: {
        name: "",
        type: 1,
        inventory_id: 1,
        area: 1,
        phone: "",
        account: 0,
        address: "",
      },
    };
  },
  mounted() {
    this.getProjects();
    if (this.selectedSupplier) {
      this.placeholder = this.selectedSupplier.name;
    }
    if (this.$route.name != "ReturnPurchase") {
      this.addsupplier = true;
    }
    if (this.selectedSupplier) {
      document.querySelector(".productQuery input").focus();
    } else {
      document.querySelector(".supplierQuery input").focus();
    }
  },
  methods: {
    selectProject() {
      this.$emit("selectedSupplier", {
        supplier: this.selectedSupplier,
        project_id: this.project_id,
      });
    },
    getProjects() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .get("/projects")
        .then((res) => {
          this.projects = res.data;
        })
        .finally(() => loading.close());
    },
    setValue(value) {
      this.selectedSupplier = value;
      this.value = value;
      if (this.value != null) {
        this.placeholder = value.name;
        this.supplierAccount = value.balance + Number(value.account);
      } else {
        this.placeholder = "";
      }
      if (this.value) {
        setTimeout(() => {
          document.querySelector(".productQuery input").focus();
        }, 100);
      } else {
        setTimeout(() => {
          document.querySelector(".supplierQuery input").focus();
        }, 100);
      }
    },
    resetSearch() {
      if (this.productsLength == 0) {
        this.setValue(null);
        this.$emit("selectedSupplier", {
          supplier: null,
          project_id: this.project_id,
        });
      }
    },
    supplierSelected() {
      if (this.value != "0") {
        console.log("supplierSelected", this.value);
        this.selectedSupplier = this.options.filter((supplier) => {
          if (supplier.id == this.value) {
            return supplier;
          }
        })[0];
        if (this.selectedSupplier) {
          this.placeholder = this.selectedSupplier.name;
          this.supplierAccount =
            +this.selectedSupplier.balance + +this.selectedSupplier.account;
          setTimeout(() => {
            if (!this.useParcode) {
              document.querySelector(".productQuery input").focus();
            } else {
              document
                .querySelector(".parcodeSearch input[type='text']")
                .focus();
            }
          }, 100);
        }
        this.$emit("selectedSupplier", {
          supplier: this.selectedSupplier,
          project_id: this.project_id,
        });
      } else {
        this.value = "";
        this.handleSearchEnter();
      }
    },
    remoteMethod(query) {
      if (query !== "") {
        this.selectedLabel = query;
        this.loading = true;
        axiosApi
          .get(`suppliers/search?query=${query}`)
          .then((res) => {
            this.loading = false;
            this.options = res.data;
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
          });
      } else {
        this.options = [];
      }
    },
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    handleSearchEnter() {
      this.supplierForm.name = this.selectedLabel;
      this.supplierForm.phone = "";
      this.supplierForm.account = 0;
      // alert("new")
      this.addFormVisible = true;
      setTimeout(() => {
        document.querySelector(".formInput1 input").focus();
      }, 100);
    },
    addNewCustomer() {
      this.$refs["supplierForm"].validate((valid) => {
        if (valid) {
          axiosApi
            .post("suppliers", this.supplierForm)
            .then((res) => {
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات العميل بنجاح",
                type: "success",
                duration: 1500,
              });
              this.addFormVisible = false;
              this.selectedSupplier = res.data;
              this.placeholder = res.data.name;
              this.supplierAccount =
                res.data.balance + Number(res.data.account);

              this.value = res.data.id;

              this.$emit("selectedSupplier", {
                supplier: this.selectedSupplier,
                project_id: this.project_id,
              });
              this.index = 1;

              this.selectedLabel = "";
              this.$refs["supplierForm"].resetFields();
            })
            .catch(() => {
              this.$notify({
                title: "حدث خطأ",
                message: "عفوا رقم الهاتف مستخدم لحساب اخر ",
                type: "error",
                duration: 1500,
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    focusNext() {
      if (this.index < 4) {
        this.index += 1;
      } else {
        this.index = 1;
      }
      let input = ".formInput" + this.index + " input";
      setTimeout(() => {
        document.querySelector(input).focus();
      }, 100);
    },
    accessLinks(link) {
      let menu = JSON.parse(localStorage.getItem("permissionNames"));
      return menu.includes(link);
    },
  },
};
</script>
